import { 
  useEffect
} from 'react';
import { Route } from 'react-router-dom';
import { useHistory } from "react-router-dom";
import navBarStore from '../../../stores/NavBar';

const RouteC = ({ component: Component, isAuthenticated, ...rest }) => {
  const history = useHistory();
  const navBar = navBarStore();

  useEffect(() => {
    if ( rest.fullscreen === true ) {
      navBar.hide();
    } else {
      navBar.show();
    }

    if (rest.beforeGo) {
      rest.beforeGo()
    }
  }, [history.location.pathname])

  console.log('pathname change')

  return (
    <Route
      {...rest}
      render={props =>
        <Component {...props} />
      }
    />
  );
}

export default RouteC;